// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Vcit","field":"styles_field__VlB-y","fieldCol":"styles_fieldCol__C8A7_","diffCol":"styles_diffCol__Nn2bU","diff":"styles_diff__3H92l"};